import type { Stats } from "@/stats/types";
import {
  Community,
  DragHandGesture,
  EmojiTalkingHappy,
  Heart,
  MultiBubble,
  User,
  UserCrown,
  UserStar,
} from "@iconoir/vue";
import type { Component } from "vue";

export const allStatsItems: Record<
  keyof Stats,
  {
    text: string;
    icon: Component;
  }
> = {
  totalContacts: {
    text: "Kontakte",
    icon: Community,
  },
  totalPotentialCoreActivists: {
    text: "potentielle Kernaktive",
    icon: UserStar,
  },
  totalHouseSpeakers: {
    text: "Haussprecher:innen",
    icon: UserCrown,
  },
  totalUsers: {
    text: "Nutzer:innen",
    icon: User,
  },
  totalCanvasses: {
    text: "Haustüraktionen",
    icon: Heart,
  },
  totalDoorsKnocked: {
    text: "Türen geklopft",
    icon: DragHandGesture,
  },
  totalDoorsOpened: {
    text: "Türen geöffnet",
    icon: EmojiTalkingHappy,
  },
  totalConversations: {
    text: "Gespräche",
    icon: MultiBubble,
  },
};
